module.exports = __webpack_public_path__ + "static/software-83bd5ef7496186c265f3cbbe1ef1d74b.jpg";